<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 22 22"
    fill="none"
    class="icon-share">
    <g clip-path="url(#clip0_467_15392)">
      <path
        class="icon-share__path"
        d="M1.8412 19.25L21.082 11L1.8412 2.75L1.83203 9.16667L15.582 11L1.83203 12.8333L1.8412 19.25Z"
        :fill="color" />
    </g>
    <defs>
      <clipPath id="clip0_467_15392">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: Number,
      default: 22,
    },
    color: {
      type: String,
      default: '#212444',
    },
  });
</script>

<style lang="scss" scoped>
  .icon-share {
    .icon-share__path {
      fill: var(--bs-primary);
    }
  }
</style>
